/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * 230208 商品ページ内左側詳細箇所アコーディオン  
 */
jQuery(function(){
  if(jQuery('.accordion_wrap').data('accordion') !== undefined) {
    jQuery('.accordion_ttl').click(function(){
      jQuery(this).toggleClass('active');
      jQuery(this).next('.item-detail-ext').slideToggle();
    });
  }
});

/**
 * 231022 商品ページ　追従カート帯
 */
jQuery(function(){
  jQuery('.custom_show_sticky_buy').click(function(){
    jQuery('#custom_show_sticky').addClass('is_active');
  });
  jQuery('.custom_show_sticky_closebtn').click(function(){
    jQuery('#custom_show_sticky').removeClass('is_active');
  });
});


/*============================================================================
  240229 商品ページ　モーダル
==============================================================================*/
jQuery(function(){
	var open = jQuery('.product-modal-open'),
		close = jQuery('.product-modal-close'),
		container;

	open.on('click',function(){	
    var target = jQuery(this).data('target');
    container = document.getElementById(target);
    jQuery(container).addClass('active');
    jQuery('html, body').addClass('scrollStop');
    if(jQuery('.product-sticky-bar').hasClass('is-visible')) {
      jQuery('.product-sticky-bar').css('display', 'none');
    }
		return false;
	});

	close.on('click',function(){	
		jQuery(container).removeClass('active');
    jQuery('html, body').removeClass('scrollStop');
    if(jQuery('.product-sticky-bar').hasClass('is-visible')) {
      jQuery('.product-sticky-bar').css('display', 'block');
    }
	});

	jQuery(document).on('click',function(e) {
		if(!jQuery(e.target).closest('.product-modal-body').length) {
			jQuery(container).removeClass('active');
      jQuery('html, body').removeClass('scrollStop');
      if(jQuery('.product-sticky-bar').hasClass('is-visible')) {
        jQuery('.product-sticky-bar').css('display', 'block');
      }
		}
	});
});


/*============================================================================
  2408 商品ページ　在庫数表示
==============================================================================*/
jQuery(function(){
  jQuery('.color-swatch').on('click',function(){
    var spanValue = jQuery(this).find('span.sr-only').text();
    jQuery('span.tatsu-inventory_quantity').each(function() {
      if (jQuery(this).hasClass('active')) {
        jQuery(this).removeClass('active');
      }
      var produname = jQuery(this).data('produname');
      if (produname === spanValue) {
        jQuery(this).addClass('active');
      }
    });
  }); 
});


/*============================================================================
  2410 ios 自動再生動画を表示するとき上にコントロール画面が出てしまうためタップ後に表示に変更
==============================================================================*/
const videos = document.querySelectorAll(".auto_video_data");

videos.forEach(video => {
  video.addEventListener("click", () => {
    video.controls = !video.controls;
  });
});


/*============================================================================
  2410 iframeの動画を複数設置した場合に全て自動再生にする処理（処理なしだと一つのみ再生される）
==============================================================================*/
jQuery(function(){
  const iframes = jQuery('.video_player iframe');
  const players = [];
  const stoppedPlayers = {};

  iframes.each(function (index) {
    const player = new Vimeo.Player(this);
    players.push(player);

    player.on('pause', () => {
      stoppedPlayers[index] = true;
    });

    player.on('play', () => {
      stoppedPlayers[index] = false;
    });
  });

  function checkVisibility() {
    players.forEach((player, index) => {
      const $iframe = jQuery(iframes[index]);
      const offset = $iframe.offset().top;
      const windowTop = jQuery(window).scrollTop();
      const windowBottom = windowTop + jQuery(window).height();

      if (offset < windowBottom && offset + $iframe.height() > windowTop) {
        if (!stoppedPlayers[index]) {
          setTimeout(function(){
            player.play();
          },100);
        }
      }
    });
  }

  jQuery(window).on('scroll resize', checkVisibility);
  checkVisibility();
});

/*============================================================================
  25_05 商品ページナビゲーション処理
==============================================================================*/
jQuery(function(){
  jQuery(window).on('scroll', function() {
    if (jQuery('.page-nav').length > 0) {
      var scrollTop = jQuery(window).scrollTop(); // 現在のスクロール位置
      var breadcrumbOffset = jQuery('#breadcrumb').offset().top; // breadcrumbの位置
    
      if (scrollTop >= breadcrumbOffset) {
        jQuery('.page-nav').addClass('active');
      } else {
        jQuery('.page-nav').removeClass('active');
      }
    }
  });

  jQuery('.page-nav a[href^="#"]').on('click', function(e) {
    e.preventDefault();
  
    var targetId = jQuery(this).attr('href');
    var navHeight = jQuery('.page-nav').outerHeight();

    if (targetId === '#' || targetId === '') {
      jQuery('html, body').animate({ scrollTop: 0 }, 600);
    } else {
      var target = jQuery(targetId);
      if (target.length) {
        var targetPosition = target.offset().top - navHeight;
        jQuery('html, body').animate({
          scrollTop: targetPosition
        }, 600);
      }
    }
  });
});

/*============================================================================
  25_12 記事ページ　２カラム表示のメタフィールド用処理
==============================================================================*/
(function () {
  const syncImageHeights = () => {
    document.querySelectorAll('.blog-two-column').forEach(block => {
      const wraps = block.querySelectorAll('.img-wrap');
      if (wraps.length < 2) return;

      // リセット
      wraps.forEach(w => w.style.height = 'auto');

      let max = 0;
      wraps.forEach(w => {
        max = Math.max(max, w.offsetHeight);
      });

      wraps.forEach(w => {
        w.style.height = max + 'px';
      });
    });
  };

  // 初期実行
  window.addEventListener('load', syncImageHeights);

  // リサイズ対応（間引き）
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncImageHeights, 100);
  });

  // 画像遅延読込対策
  document.querySelectorAll('.blog-two-column img').forEach(img => {
    if (img.complete) return;
    img.addEventListener('load', syncImageHeights);
  });

})();
(function () {
  document.querySelectorAll('.blog-two-column').forEach(block => {
    let prev = block.previousElementSibling;
    let next = block.nextElementSibling;

    const isEmptyP = el =>
      el &&
      el.tagName === 'P' &&
      el.textContent.replace(/\u00a0/g, '').trim() === '';

    if (isEmptyP(prev)) prev.remove();
    if (isEmptyP(next)) next.remove();
  });
})();

/*============================================================================
  25_12 記事ページ　Carousel用処理
==============================================================================*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.blog-carousel').forEach(carousel => {
    const slideCount = carousel.querySelectorAll('.swiper-slide').length;

    new Swiper(carousel, {
      slidesPerView: 1,
      loop: slideCount > 1,

      navigation: {
        nextEl: carousel.querySelector('.swiper-button-next'),
        prevEl: carousel.querySelector('.swiper-button-prev'),
      },

      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    /* 1枚のときはUIを非表示 */
    if (slideCount <= 1) {
      const prev = carousel.querySelector('.swiper-button-prev');
      const next = carousel.querySelector('.swiper-button-next');
      const pagination = carousel.querySelector('.swiper-pagination');

      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      if (pagination) pagination.style.display = 'none';
    }
  });
});


/*============================================================================
  26_03 TOPへ戻るボタン スムーススクロール・フェードアウト処理
==============================================================================*/
const backToTopBtn = document.querySelector('.back-to-top');
if (backToTopBtn) {
window.addEventListener('scroll', () => {
  if (window.scrollY > 100) {
    backToTopBtn.classList.add('show');
  } else {
    backToTopBtn.classList.remove('show');
  }
});
backToTopBtn.addEventListener('click', (e) => {
  e.preventDefault();
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});
}